export const SCHEMA_NAME = "CivilPapersNew";

export const FIELDS = {
  CIVIL_PAPER_ID: "civilPaperID",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  USER: "user",
  CRN: "crn",
  COURT: "court",
  PLAINTIFF_F_NAME: "plaintiffFName",
  PLAINTIFF_L_NAME: "plaintiffLName",
  PLAINTIFF_M_NAME: "plaintiffMName",
  PLAINTIFF_BUSINESS: "plaintiffBusiness",
  DATE_PAID: "datePaid",
  BIO_ID: "bioID",
  JACKET_ID: "jacketID",
  DEFENDANT_BUSINESS_ID: "defendantBusinessID",
  AGENCY_COUNTY: "agencyCounty",
  AGENCY_STATE: "agencyState",
  COMMENTS: "comments",
  CIVIL_PAPER_TYPE: "civilPaperType",
  FILE_NUMBER: "fileNumber",
  DATE_RECEIVED: "dateReceived",
  TIME_RECEIVED: "timeReceived",
  STATUS: "status",
  ORIGINATING_AGENCY_TYPE: "originatingAgencyType",
  EXPIRATION_DATE: "expirationDate",
  ORIGINAL_EXPIRATION_DATE: "originalExpirationDate",
  BANKRUPTCY_CASE_NUMBER: "bankruptcyCaseNumber",
  DEPOSIT_SUPPLIED_BY: "depositSuppliedBy",
  DOCKET_DATE: "docketDate",
  DOCKET_TIME: "docketTime",
  EXECUTION_DATE: "executionDate",
  EXECUTION_TIME: "executionTime",
  PLAINTIFF_DESCRIPTION: "plaintiffDescription",
  DEFENDANT_DESCRIPTION: "defendantDescription",
  DOCUMENT_TYPE: "documentType",
  ORIGINATING_PARTY_BIO_ID: "originatingPartyBioID",
  ORIGINATING_PARTY_BUSINESS_ID: "originatingPartyBusinessID",
  CREATOR_STAFF_ID: "creatorStaffID",
  DATE_COLLECTED: "dateCollected",
  COLLECTED_BY_STAFF_ID: "collectedByStaffID",
  STATUS_EFFECTIVE_DATE: "statusEffectiveDate",
  STATUS_DATE: "statusDate",
  MONEY_COLLECTED: "moneyCollected",
  PROCESS_FEE: "processFee",
  LIST_OF_DOCUMENTS: "listOfDocuments",
  BILL_FOR_THIS_CASE: "billForThisCase",
  BASIS_FOR_COMMISSION: "basisForCommission",
  SEALED: "sealed",
  COURT_NUMBER: "courtNumber",
  INVOICE_DATE: "invoiceDate",
  NON_BILLABLE: "nonBillable",
  EVICTION_DATE: "evictionDate",
  OVERAGE_AMOUNT: "overageAmount",
  FORECLOSURE_DATE: "foreclosureDate",
  OVERAGE_PAID: "overagePaid",
};
